import React, { useContext, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import AuthClient from "../../api/AuthClient";
import DeleteProfilePhotoApi from "../../api/DeleteProfilePhotoApi";
import AddOrSetPhotoAsProfileApi from "../../api/AddOrSetPhotoAsProfileApi";
import { Modal } from "react-bootstrap";
import Header from "../Header";
import { CurrentPathContext } from "../../GlobalContext/currentPathContext";
import { routes } from "../../routes/routes";
import { iconsImgs } from "../../utils/icons";
import { getUserAvatar } from "../../utils/getMedia";
import { UserProfileInfoContext } from "../../GlobalContext/UserProfileInfoContext";
import "../PromotersPages/promotersPages.scss";

/** `photo` query may be a user photo key or a full media URL (older links). */
const resolvePhotoZoomSrc = (photo: string): string => {
  const trimmed = photo.trim();
  if (/^https?:\/\//i.test(trimmed)) {
    const sep = trimmed.includes("?") ? "&" : "?";
    return `${trimmed}${sep}t=${Date.now()}`;
  }
  return getUserAvatar(`${trimmed}?${Date.now()}`);
};

const ProfilePhotoZoom: React.FC = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const selectedPhoto = params.get('photo');

  const { callBackUrl, city, Id, photoId } = useParams();
  const [isConfirmModalOpen, setConfirmationModalOpen] = useState(false);
  const [isDeletingPhoto, setIsDeletingPhoto] = useState(false);
  const { userProfileInfo, setUserProfileFieldValues } = useContext(UserProfileInfoContext);
  const { setCurrentPath } = useContext(CurrentPathContext);

  const handleClose = () => {
    if (callBackUrl === "user-profile") {
      setCurrentPath(routes.UserProfile);
      navigate(-1);
    } else if (callBackUrl === "group-detail") {
      navigate(`/group-detail/${city}/${Id}`);
    } else {
      setCurrentPath("rapp/alsoGoingOutGroupDetail");
      navigate(-1)
    }
  }

  const DeleteProfileImage = async () => {
    const authClient = new AuthClient();
    const deleteProfilePhotoApi = new DeleteProfilePhotoApi(authClient);
    const updatePhotoCountApi = new AddOrSetPhotoAsProfileApi(authClient);

    if (Id) {
      const picturesCount = userProfileInfo[0].CountProfilePictures;
      const profileIndex = Number(photoId) === 0 ? picturesCount : Number(photoId);
      const updatedPicturesCount = Math.max(picturesCount - 1, 0);

      setIsDeletingPhoto(true);

      try {
        const deleteResponse = await deleteProfilePhotoApi.deleteProfilePhoto(Id, profileIndex);
        if (deleteResponse?.statusCode !== 200) {
          return;
        }

        const updateCountResponse = await updatePhotoCountApi.addImageOrSetPhotoAsProfile(updatedPicturesCount, false);
        if (updateCountResponse?.statusCode !== 200) {
          return;
        }

        setUserProfileFieldValues(Id, { CountProfilePictures: updatedPicturesCount });
        setConfirmationModalOpen(false);
        navigate(`/user-profile`);
      } catch (error) {
        console.log(error);
      } finally {
        setIsDeletingPhoto(false);
      }
    }
  }

  if (!selectedPhoto) {
    return <p>No photo selected.</p>;
  }

  return (
    <>
      <Header />

      <div className="centerGroup">
        <div className="desktopUI ">

          <Modal centered show={isConfirmModalOpen} onHide={() => setConfirmationModalOpen(false)}>
            <Modal.Body className="text-center">
              {isDeletingPhoto ? "Deleting photo..." : "Are you sure you want to delete this picture?"}
            </Modal.Body>

            <Modal.Footer>
              <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                onClick={() => { DeleteProfileImage() }}
                disabled={isDeletingPhoto}>
                {isDeletingPhoto ? "Deleting..." : "Yes"}
              </button>
              <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                onClick={() => setConfirmationModalOpen(false)}
                disabled={isDeletingPhoto}>
                No
              </button>
            </Modal.Footer>
          </Modal>

          <div className="row">
            <div className="d-flex justify-content-start col-6">
              <button className="BtnTop yellowTxt btn text-decoration-none backBtn" onClick={() => navigate(-1)}>
                Back
              </button>
            </div>

            {/* Preventing users from deleting their photo if it is currently set as their profile picture. */}
            {photoId !== "0" && callBackUrl === "user-profile" &&
              <div className="d-flex justify-content-end col-6">
                <button className="BtnTop yellowTxt btn text-decoration-none" onClick={() => { setConfirmationModalOpen(true) }} >
                  Delete Photo
                </button>
              </div>
            }
          </div>

          <div className="new">
            <TransformWrapper>
              <TransformComponent>
                {(selectedPhoto === "male" || selectedPhoto === "female") ?
                  <img src={selectedPhoto === "male" ? iconsImgs.Boy_96x96 : iconsImgs.Girl_96x96} alt=""
                    className="p-0 mt-4 groupDetailImg"
                  /> :
                  <img src={resolvePhotoZoomSrc(selectedPhoto)} alt=""
                    className="p-0 mt-4 groupDetailImg"
                  />
                }
              </TransformComponent>
            </TransformWrapper>
          </div>

          <div className="d-flex justify-content-center pt-2 pb-4">
            <button type="button" className="zoomPageButton" onClick={handleClose}>
              Close
            </button>
          </div>

        </div>
      </div>
    </>
  );
};

export default ProfilePhotoZoom;
